<template>
    <router-view />
</template>
<script>
export default {
    name: "layout",
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/layout.vue